<div class="buckets-widget">
  <lib-question-hint
    class="animate__animated"
    (click)="openInformationOverlay()"
    [hint]="'SLIDES.swipe_cards_into_correct_section' | translate">
  </lib-question-hint>

  <lib-buckets-widget
    [buckets]="slideData?.buckets"
    [spacing]="slideData.spacing"
    [slide]="slideData"
    [animationOptions]="{ enabled: animationEnabled, animation: slideData.animation, delay: slideData.animationDelay }"
    (interactionCompleted)="interactionCompleted.emit($event)">
  </lib-buckets-widget>

  @if (showInformationOverlay) {
    <div class="information-overlay" (click)="closeInformationOverlay()">
      <div class="overlay-icon">
        <lib-question-answer-option-code [index]="0"></lib-question-answer-option-code>
        <lib-icon icon="arrow-left" class="arrow-icon" [size]="16"></lib-icon>
        <lib-icon icon="hand-pointing" class="hand-icon" [size]="32"></lib-icon>
        <lib-icon icon="arrow-right" class="arrow-icon" [size]="16"></lib-icon>
        <lib-question-answer-option-code [index]="1"></lib-question-answer-option-code>
      </div>
      <div class="overlay-text">
        {{ 'SLIDES.swipe_cards_left_right_into_correct_section' | translate }}
      </div>
      <app-icon-button
        class="information-overlay-close"
        [ariaLabel]="'Close'"
        icon="x"
        iconClass="white">
      </app-icon-button>
    </div>
  }
</div>
